import { PaginatedListResult, usePaginatedList } from "@hooks/usePaginatedList";
import { ServicesURL } from "@utils/utilsApi";
import { CarouselListItem } from "../types";

interface UseCarouselsListArgs {
  corporateId: string;
  initiativeId: number;
  page: number;
  pageSize: number;
  search?: string;
}

export const useCarouselsList = ({
  corporateId,
  initiativeId,
  page,
  pageSize,
  search,
}: UseCarouselsListArgs): PaginatedListResult<CarouselListItem> => {
  const url =
    corporateId && initiativeId
      ? `${ServicesURL.categories}/${initiativeId}/categories?corporate_id=${corporateId}`
      : null;

  return usePaginatedList<CarouselListItem>(url, {
    page,
    pageSize,
    search,
    sort: "asc",
  });
};
